// src/components/common/Footer/Footer.tsx
import React from 'react';
import {
  FooterContainer,
  FooterWrapper,
  TopRow,
  LogoContainer,
  NavLinks,
  FooterLink,
  SocialIcons,
  BottomRow,
  FooterTextLeft,
  FooterTextRight,
} from './Footer.styles';
import { FaFacebookF, FaInstagram, FaTwitter } from 'react-icons/fa';

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterWrapper>
        {/* Top row: Logo / Navigation / Social Icons */}
        <TopRow>
          <LogoContainer>
            <img src="hbi-logoo.svg" alt="HB International Logo" />
          </LogoContainer>

          <NavLinks>
            <FooterLink to="/about">About Us</FooterLink>
            <FooterLink to="/missions">Missions</FooterLink>
            <FooterLink to="/events">Events</FooterLink>
            <FooterLink to="/volunteer">Volunteer</FooterLink>
            <FooterLink to="/donate">Donate</FooterLink>
            <FooterLink to="/contact-us">Contact</FooterLink>
            {/* New link to Terms of Service */}
            <FooterLink to="/terms-of-service">Terms of Service</FooterLink>
            {/* New link to Privacy Policy */}
            <FooterLink to="/privacy-policy">Privacy Policy</FooterLink>
          </NavLinks>

          <SocialIcons>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>
          </SocialIcons>
        </TopRow>

        {/* Bottom row: Footer text */}
        <BottomRow>
          <FooterTextLeft>Hope Beyond International © 2025</FooterTextLeft>
          <FooterTextRight>
            All Creative Rights Protected by Hope Beyond International
          </FooterTextRight>
        </BottomRow>
      </FooterWrapper>
    </FooterContainer>
  );
};

export default Footer;
